import React from 'react'

const ContextSiteContents =  React.createContext();

export default ContextSiteContents
